import { CommonModule } from "@angular/common";
import { ChangeDetectionStrategy, Component, computed, inject } from "@angular/core";
import { toSignal } from "@angular/core/rxjs-interop";
import { AmazonInvoice } from "@front/m19-api-client";
import { AccountMarketplaceService, AccountSelectionService } from "@front/m19-services";
import {
  IDataTableComponent,
  ITableDataSource,
  ITableImports,
  SpinnerComponent,
  IIconComponent,
  IAlertComponent,
} from "@front/m19-ui";
import { TranslocoDirective } from "@jsverse/transloco";
import { AmazonInvoicesRowComponent } from "./amazon-invoices-row.component";
import { AmazonInvoicesService } from "./amazon-invoices.service";
import { OverdueAmazonInvoiceWarningComponent } from "./overdue-amazon-invoice-warning.component";
import { AccountLinkingPageComponent } from "@m19-board/onboarding/account-linking-page.component";

@Component({
  selector: "app-amazon-invoices",
  templateUrl: "./amazon-invoices.component.html",
  imports: [
    CommonModule,
    SpinnerComponent,
    TranslocoDirective,
    IDataTableComponent,
    ITableImports,
    AmazonInvoicesRowComponent,
    OverdueAmazonInvoiceWarningComponent,
    IAlertComponent,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AmazonInvoicesComponent {
  private readonly accountSelectionService = inject(AccountSelectionService);
  private readonly amazonInvoicesService = inject(AmazonInvoicesService);

  readonly accountMarketplaceSelection = toSignal(this.accountSelectionService.singleAccountMarketplaceSelection$, {
    requireSync: true,
  });
  readonly onM19Seat = computed(() => {
    const accountMarketplace = this.accountMarketplaceSelection();
    return (
      accountMarketplace.dspAdvertiser &&
      AccountMarketplaceService.m19SeatProfileIds.includes(accountMarketplace.dspAdvertiser.profileId)
    );
  });
  readonly loading = this.amazonInvoicesService.loading;
  readonly amazonInvoices = this.amazonInvoicesService.amazonInvoices;

  readonly dataSource = new ITableDataSource<AmazonInvoice>(this.amazonInvoices);
}
